import { render, staticRenderFns } from "./LoansCalculator.vue?vue&type=template&id=3f2a429c&"
import script from "./LoansCalculator.vue?vue&type=script&lang=js&"
export * from "./LoansCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports